// components/skydata/pheno-popup.tsx
const PhenoPopup = ({ pheno }: { pheno: types.Pheno }) => {
  console.log("pheno", pheno);
  return (
    <div className="scaled-popup max-w-[220px] mx-auto bg-white shadow-md rounded-xl p-2 text-center">
      {/* City name */}
      <div className="uppercase text-xs font-semibold text-blue-700 tracking-wide mb-1">
        {pheno.city}
      </div>

      {/* Day & Night container */}
      <div className="flex justify-between items-center gap-3">
        {/* Day */}
        <div className="flex flex-col items-center bg-blue-100 rounded-lg px-2 py-1 shadow-sm">
          <span className="text-base font-bold text-blue-600">
            {pheno.temp_day}°C
          </span>
          <img
            src={`/images/pheno/${pheno.pheno_day}.svg`}
            alt="Өдрийн үзэгдэл"
            className="h-6 w-6"
          />
          <span className="text-xs text-gray-600 mt-0.5">Өдөр</span>
        </div>

        {/* Night */}
        <div className="flex flex-col items-center bg-gray-800 rounded-lg px-2 py-1 shadow-sm">
          <span className="text-base font-bold text-white">
            {pheno.temp_night}°C
          </span>
          <img
            src={`/images/pheno/${pheno.pheno_night}.svg`}
            alt="Шөнийн үзэгдэл"
            className="h-6 w-6"
          />
          <span className="text-xs text-gray-300 mt-0.5">Шөнө</span>
        </div>
      </div>
    </div>
  );
};

export default PhenoPopup;
